// extracted by mini-css-extract-plugin
export default {"main_container":"UserMyNotes_main_container__POxJD","title":"UserMyNotes_title__AEfYR","primary":"UserMyNotes_primary__AfI+h"};